var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fetch_data)?_c('div',[_c('div',{staticClass:"index",attrs:{"id":"container"}},[_c('EventList',{attrs:{"events":_vm.fetch_data.events,"storage_key":''}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }